/**
 * @public
 */
export class Cache {
    static empty() {
        return new Cache();
    }
    _storage = new WeakMap();
    constructor() { }
    get(rule, ifMissing) {
        let outcomes = this._storage.get(rule);
        if (outcomes === undefined) {
            outcomes = ifMissing();
            this._storage.set(rule, outcomes);
        }
        return outcomes;
    }
}
//# sourceMappingURL=cache.js.map